var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',{staticClass:"d-flex justify-content-center p-3 bg-light"},[_c('span',{staticClass:"pre-wrap",domProps:{"innerHTML":_vm._s(_vm.$t('pages.home.footer.text', {
      currentYear: new Date().getFullYear()
    }))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }